import type { FC, ReactNode } from 'react'

import { testimonials } from '@/constants/content'

const SOURCE_LOGO = {
    trustpilot: '/images/group-16.svg',
    google: '/images/ng/google-g.svg'
}

type TestimonialsProps = {
    heading?: string
}

export const Testimonials: FC<TestimonialsProps> = ({
    heading = 'What Our Customers Say'
}): ReactNode => {
    return (
        <section className='testimonial-section section-padding'>
            <div className='w-layout-blockcontainer container w-container'>
                <div className='section-content-wrapper'>
                    <div className='section-title-wrapper align-center testimonial' data-reveal>
                        <h2 className='section-title'>
                            {heading}
                        </h2>

                        <p className='section-subtitle testimonial'>
                            {'Rated '}

                            <span className='subtitle-span'>
                                5.0/5
                            </span>

                            {' from 25 Google reviews'}
                        </p>
                    </div>

                    <div className='testimonial-wrapper' data-reveal-stagger='0.07'>
                        {testimonials.map((testimonial) => (
                            <div key={testimonial.name + testimonial.quote} className='single-testimonial-card'>
                                <div className='testimonial-top'>
                                    <img
                                        loading='lazy'
                                        src={SOURCE_LOGO[testimonial.source]}
                                        width={36}
                                        height={36}
                                        alt={testimonial.source === 'google' ? 'Google' : 'Trustpilot'}
                                    />

                                    <div className='testimonial-ratings' role='img' aria-label='Rated 5 out of 5 stars'>
                                        {[0, 1, 2, 3, 4].map((star) => (
                                            <img
                                                key={star}
                                                loading='lazy'
                                                src='/images/start.svg'
                                                alt=''
                                            />
                                        ))}
                                    </div>
                                </div>

                                <div className='testimonial-bottom'>
                                    <p className='testimonial-content'>
                                        {testimonial.quote}
                                    </p>

                                    <div className='testimonial-author'>
                                        {testimonial.avatar ? (
                                            <img
                                                loading='lazy'
                                                src={testimonial.avatar}
                                                alt={testimonial.name}
                                                className='testimonial-author-image'
                                            />
                                        ) : (
                                            <span
                                                className='testimonial-author-image testimonial-author-initial'
                                                aria-hidden='true'
                                            >
                                                {testimonial.name.charAt(0)}
                                            </span>
                                        )}

                                        <div className='testimonial-author-name-wrapper'>
                                            <p className='testimonial-author-name'>
                                                {testimonial.name}
                                            </p>

                                            <p className='testiomonial-author-designation'>
                                                {testimonial.designation}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
